module.exports = __webpack_public_path__ + "static/media/Done.63524d0d.svg";